import { BcDate, OnlineContentViewType } from '@bayclubs/group-classes-employee-api';
import { utils } from '@bayclubs/utils';
import { gcManagementEnumerations } from '../../interfaces/interfaces.module';

export class ReportModel {
    id: number;
    name: string;
    route: string;
    type: ReportType;
}

export enum ReportType {
    PayrollReport,
    ClubCentricReport,
    AttendanceReport,
    InstructorCentricReport,
    OnlineContentViewReport,
    AdpReport,
}

export class ClubCentricClass {
    constructor(public id: string, public name: string) {}
}

export class ReportSummaryRow {
    totalHours: number;
    totalCost: number;
}

export class ClassRow {
    clubName: string;
    clubShortName: string;
    category: string;
    classAttendance: number;
    className: string;
    date: Date;
    bcDate: utils.BcDate;
    startTime: number;
    actualLengthOfClass: number;
    billableLengthOfClass: number;
    cost: number;
    location: string;
    status: gcManagementEnumerations.EnumerationModel;
    substitution: boolean;
    cancelled: boolean;
}

export interface ReportFilter {
    className: string;
    clubIds: string[];
    dateFrom: BcDate;
    dateTo: BcDate;
    instructorId: string;
    instructorIds: string[];
    classTypeId: string;
    contentType: OnlineContentViewType;
}
